import * as React from 'react';

const BadgeIcon = (props) => {
  const { rank } = props;
  const colorId = rank === 'gold' ? 'perfect' : rank === 'silver' ? 'elite' : 'great';

  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="26" height="26" rx="13" fill={`url(#${colorId})`} />
      <g transform="translate(3.5 4.5)">
        <svg
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="Outline/Diamond/Excellence">
            <path
              id="Vector"
              d="M16.4746 4.36598V4.36563L16.4709 4.35779C15.9852 3.32293 14.9495 2.65332 13.831 2.65332H5.78803C4.66825 2.65332 3.63156 3.32397 3.1468 4.36127L3.14679 4.36127L2.61244 5.50523C2.11514 6.56799 2.28732 7.82375 3.05169 8.70369C3.05169 8.70369 3.0517 8.70369 3.0517 8.70369L8.50137 14.9799C8.50141 14.98 8.50146 14.9801 8.5015 14.9801C8.73816 15.2578 9.04171 15.4439 9.3784 15.5275L9.37915 15.5277C9.65754 15.591 9.95876 15.6113 10.2419 15.5273C10.5782 15.4433 10.8804 15.2579 11.1162 14.9825C11.1162 14.9825 11.1163 14.9824 11.1163 14.9824L16.5694 8.70609L16.5694 8.70608C17.3347 7.82478 17.5069 6.56799 17.0076 5.50351C17.0076 5.5035 17.0076 5.5035 17.0076 5.50349L16.4746 4.36598ZM3.48749 6.56945C3.50822 6.37926 3.55659 6.19105 3.64023 6.01242L3.64024 6.01239L4.17494 4.86841L4.17494 4.8684C4.4713 4.23415 5.1048 3.82471 5.78769 3.82471H5.80411L5.80444 3.82437H7.30523L6.02302 6.56945H3.48749ZM13.596 6.56945L12.3135 3.82437H13.831C14.513 3.82437 15.1461 4.2328 15.4432 4.86606L15.4536 4.8884H15.454L15.9802 6.0114L15.9802 6.01142C16.0641 6.19035 16.1125 6.3789 16.1335 6.56945H13.596ZM3.90271 7.92461C3.8521 7.86642 3.80704 7.8047 3.76561 7.7405H6L7.97817 12.6182L3.90273 7.92464L3.90271 7.92461ZM13.6191 7.7405H15.8564C15.8147 7.80517 15.7693 7.86745 15.7184 7.92597L15.7183 7.92599L11.6402 12.6198L13.6191 7.7405ZM12.3839 7.7405L9.80954 14.0881L7.23521 7.7405H12.3839ZM11.0485 3.82437L12.331 6.56945H7.28804L8.57024 3.82437H11.0485Z"
              fill="white"
              stroke="white"
              strokeWidth="0.0776415"
            />
          </g>
        </svg>
      </g>
      <defs>
        <linearGradient id="perfect" x1="13" y1="0" x2="13" y2="26" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4CA4AB" />
          <stop offset="0.36" stopColor="#ABE3E4" />
          <stop offset="0.49" stopColor="#B5ECED" />
          <stop offset="1" stopColor="#4CA4AB" />
        </linearGradient>
      </defs>
      <defs>
        <linearGradient id="elite" x1="13" y1="0" x2="13" y2="26" gradientUnits="userSpaceOnUse">
          <stop stopColor="#708189" />
          <stop offset="0.36" stopColor="#C8D1D4" />
          <stop offset="0.49" stopColor="#D5DEE2" />
          <stop offset="1" stopColor="#72838B" />
        </linearGradient>
      </defs>
      <defs>
        <linearGradient id="great" x1="13" y1="0" x2="13" y2="26" gradientUnits="userSpaceOnUse">
          <stop stopColor="#F4B513" />
          <stop offset="0.36" stopColor="#FFDF6D" />
          <stop offset="0.49" stopColor="#FFE791" />
          <stop offset="1" stopColor="#F4B513" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default BadgeIcon;
